import React from 'react';
import { createRoot } from 'react-dom/client';

import Icon from '../icons/Icons';

class CustomExportButton extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <>
        <button className="btn-circle">
          <Icon icon="export" size={12} height={16} color="#808285" />
        </button>
      </>
    );
  }
}

export const exportButtonFormatter = (cell, formatterParams, onRendered) => {
  const container = document.createElement('div');
  container.classList.add('actions-btn');
  const root = createRoot(container);

  root.render(
    <CustomExportButton
      cell={cell}
      formatterParams={formatterParams}
      onRendered={onRendered}
    />
  );

  return container;
};

export default CustomExportButton;
